// hashtagNode.js
// Hashtag inline node definition

/**
 * Hashtag inline node
 * Renders as #tag with tag information
 */
export const hashtagNode = {
    inline: true,
    atom: true,
    group: "inline",
    draggable: true,
    selectable: true,
    attrs: {
        id: {},                       // Required: tag ID
        label: {},                    // Required: display text (#tag)
        docId: {default: null},       // Document context
    },
    parseDOM: [{
        tag: "span[data-tag-id]",
        getAttrs(dom) {
            return {
                id: dom.getAttribute("data-tag-id"),
                label: dom.getAttribute("data-tag-label"),
                docId: dom.getAttribute("data-tag-doc-id"),
            };
        }
    }],
    toDOM(node) {
        const attrs = {
            class: "hashtag",
            "data-tag-id": node.attrs.id,
            "data-tag-label": node.attrs.label,
            contenteditable: "false",
            spellcheck: "false",
        };

        if (node.attrs.docId) attrs["data-tag-doc-id"] = node.attrs.docId;

        attrs["aria-label"] = `Tag: ${node.attrs.label || 'Unknown'}`;

        return ["span", attrs, `#${node.attrs.label}`];
    }
};

